 /* istanbul ignore file */
import { connect } from 'react-redux';
import IssueCollectorCongratsView from './IssueCollectorCongratsView';

const mapStateToProps = (state, ownProps) => {
    const { issueConfig } = state.issueConfig;
    
    return {
        issueConfig,
        store: ownProps.store
    };
}

const mapDispatchToProps = () => {
    return {
    
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(IssueCollectorCongratsView);